export default {
  errorTitle: 'Ошибка',
  required: 'Заполните поле',
  email: 'Некорректный адрес',
  date: 'Неверный формат даты',
  number: 'Принимаем только цифры',
  float: 'Допустимые символы 0-9, \'.\'',
  min: 'Минимум',
  max: 'Максимум',
  symbol1: 'символ',
  symbol2: 'символа',
  symbol3: 'символов',
  fio: 'Допустимые символы А-Я, \'-\'',
  ruEnString: 'Допустимые символы А-Я, A-Z, \'-\'',
  ruDotString: 'Допустимые символы А-Я, \'-\', \'.\'',
  numberRuString: 'Допустимые символы А-Я, 0-9, \'-\', \'.\'',
  address: 'Допустимые символы А-Я, 0-9, \'/\', \'-\', \'.\', \'(\', \')\'',
  phone: 'Некорректный номер телефона',
  inn: 'Некорректный ИНН',
  year: 'Некорректный год',
  snils: 'Некорректный СНИЛС',
  firstUpperCase: 'Заполните с заглавной буквы',
  agree: 'Необходимо дать согласие на обработку персональных данных',
  age: 'Вам должно быть больше',
  year1: 'года',
  year2: 'лет',
  noSpaceSymbol: 'Символ пробела недопустим',
  url: 'Введите url'
}
